import styled from 'styled-components';

export const ButtonContainer = styled.div`
  display: flex;
  gap: 48px;
  justify-content: center;
`;

export const PrimaryButtonBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
`;

export const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: center;
`;

export const SecondaryButtonBlock = styled.div`
  margin-top: 8px;
`;
